/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Constraint } from "./Constraint";
import { FieldAppearance } from "./FieldAppearance";
import { Action } from "../../commons/types/Action";
export const BaseProperty = core.serialization.object({
    key: core.serialization.string(),
    label: core.serialization.string().optional(),
    description: core.serialization.string().optional(),
    constraints: core.serialization.list(Constraint).optional(),
    readonly: core.serialization.boolean().optional(),
    appearance: FieldAppearance.optional(),
    actions: core.serialization.list(Action).optional(),
    metadata: core.serialization.any().optional(),
    treatments: core.serialization.list(core.serialization.string()).optional(),
    alternativeNames: core.serialization.list(core.serialization.string()).optional(),
});
